import { LeftOutlined, RightOutlined, DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { Button, Select, Input, Tooltip } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useViewportHeight } from "../../Main/useViewportHeight";
import FeatureUnlockRequestModal from "../FeatureRequestMailForm";

const Table = (props) => {
  const { path, head, body, pagination, paginationdata, summary, onLockedRowClick } = props;
  const [goToPage, setGoToPage] = useState("");
  const viewportHeight = useViewportHeight();
  const [hoveredRow, setHoveredRow] = useState(null);

  let tableHeight;

  if (summary === 1) {
    tableHeight = viewportHeight - 270;
  } else if (summary === 2) {
    tableHeight = viewportHeight - 350;
  } else {
    tableHeight = viewportHeight - 210;
  }

  const navigate = useNavigate();

  /* const redirect = (path) => {
    if (path) {
      navigate(path);
    }
  }; */

  const redirect = (row, e) => {
    if (row.path && row.path.featureKey) {
      e.preventDefault();
      e.stopPropagation();
      if (onLockedRowClick) {
        onLockedRowClick(row.path);
      }
    }
    else if (row.path && typeof row.path === 'string' && row.path.startsWith('/')) {
      navigate(row.path);
    }
  };

  const isExpired = (expiryDate) => {
    if (!expiryDate) return false;

    try {
      const [day, month, year] = expiryDate.split('/').map(Number);
      const expiry = new Date(year, month - 1, day);
      const today = new Date();

      const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const expiryStart = new Date(expiry.getFullYear(), expiry.getMonth(), expiry.getDate());

      return expiryStart < todayStart;
    } catch (error) {
      console.error('Error parsing date:', expiryDate, error);
      return false;
    }
  };

  const getRowClassName = (row, index) => {
    let className = "";

    if (row.path && row.path.startsWith && row.path.startsWith('/app/inventory/view/') && row.Expiry) {
      if (isExpired(row.Expiry)) {
        className += 'bg-red-100 hover:bg-red-200 ';
      }
    }

    if (row.path) {
      if (row.path.startsWith && row.path.startsWith('/')) {
        className += "border-b hover:bg-gray-100 cursor-pointer ";
      } else if (row.path.featureKey) {
        className += "border-b hover:bg-gray-50 cursor-pointer ";
      } else if (typeof row.path === 'string') {
        className += "border-b bg-white ";
      } else {
        className += "border-b bg-white ";
      }
    } else {
      className += "border-b bg-white ";
    }

    if (!className.includes('bg-red-100')) {
      className += "bg-white";
    }

    return className;
  };

  const handleRowClick = (row, e) => {
    if (row.path && row.path.featureKey) {
      e.preventDefault();
      e.stopPropagation();
      if (onLockedRowClick) {
        onLockedRowClick(row.path);
      }
    } else if (row.path && row.path.startsWith('/')) {
      navigate(row.path);
    }
  };

  const isRowClickable = (row) => {
    return row.path && (
      (typeof row.path === 'string' && row.path.startsWith('/')) ||
      (row.path.featureKey)
    );
  };

  const getRowTooltip = (row) => {
    if (row.path && row.path.featureKey) {
      return row.path.message || "🔒 Click to request access to this feature";
    }
    return null;
  };

  const getRowCursor = (row) => {
    if (row.path && (
      (typeof row.path === 'string' && row.path.startsWith('/')) ||
      (row.path.featureKey)
    )) {
      return 'pointer';
    }
    return 'default';
  };

  let show = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
  ];

  const handlePageChange = (page) => {
    let data = {
      ...pagination,
      currentPage: page,
    };
    paginationdata(data);
    setGoToPage("");
  };

  const handleNext = () => {
    let currentPage = parseInt(pagination?.currentPage) + 1;

    if (currentPage <= parseInt(pagination?.totalPages)) {
      handlePageChange(currentPage);
    }
  };

  const handlePrevious = () => {
    let currentPage = parseInt(pagination?.currentPage) - 1;

    if (currentPage > 0) {
      handlePageChange(currentPage);
    }
  };

  const handleFirst = () => {
    handlePageChange(1);
  };

  const handleLast = () => {
    handlePageChange(pagination?.totalPages);
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPage);
    if (pageNumber && pageNumber >= 1 && pageNumber <= pagination?.totalPages) {
      handlePageChange(pageNumber);
    } else {
      setGoToPage("");
    }
  };

  const generatePageNumbers = () => {
    const currentPage = parseInt(pagination?.currentPage) || 1;
    const totalPages = parseInt(pagination?.totalPages) || 1;
    const pages = [];

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 6) {
        for (let i = 1; i <= 9; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 5) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 8; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 4; i <= currentPage + 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const [selectedFeature, setSelectedFeature] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLockedClick = (e, feature) => {
    e.preventDefault();
    setSelectedFeature(feature);
    setIsModalOpen(true);
  };

  return (
    <div className="flex-1" style={{ maxHeight: `${tableHeight}px` }} >
      <div className="w-full rounded-md overflow-hidden flex flex-col mt-4 h-full">
        <div className="flex-1 overflow-auto hide-scrollbar">
          <table className="w-full min-w-full ">
            {head?.length > 0 && (
              <thead>
                <tr className="border-b">
                  {head?.map((value, index) => {
                    return (
                      <td
                        className={
                          index === head?.length - 1
                            ? "p-4 text-gray-500 text-center sticky top-0 bg-white z-10"
                            : value?.class
                              ? value?.class + " sticky top-0 bg-white z-10"
                              : "p-4 text-gray-500 sticky top-0 bg-white z-10"
                        }
                        style={{ position: "sticky", top: 0 }}
                      >
                        {value?.name}
                      </td>
                    );
                  })}
                </tr>
              </thead>
            )}
            {/*   {body?.length > 0 && (
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr
                      className={
                        path
                          ? "border-b hover:bg-gray-100 cursor-pointer bg-white "
                          : "border-b hover:bg-gray-100 bg-white "
                      }
                      onClick={() => redirect(value?.path)}
                    >
                      {head?.map((val, ind) => {
                        return Object?.keys(value)?.includes(val?.name) ? (
                          <td
                            className={
                              ind === head?.length - 1
                                ? "p-4 text-center"
                                : val?.className
                                  ? val?.className
                                  : "p-4"
                            }
                          >
                            {value?.[val?.name] ? value?.[val?.name] : "-"}
                          </td>
                        ) : (
                          <td className="p-4">-</td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            )} */}

            {/* {body?.length > 0 && (
        <tfoot className="">
          <tr>
            <td colSpan={head?.length} className="p-4">
              <div className="flex justify-between text-gray-500">
                <div>
                  <span className="pr-3">Show</span>
                  <Select
                    className="w-20 text-regular"
                    value={10}
                    options={show}
                  />
                  <span className="pl-5">1 - 10 of 100 Items</span>
                </div>
                <div>
                  <span>
                    <Button className="px-2">
                      <div className="text-center text-xs text-gray-600">
                        <LeftOutlined />
                      </div>
                    </Button>
                  </span>
                  <span className="px-3">1 out of 10</span>
                  <span>
                    <Button className="px-2">
                      <div className="text-center text-xs text-gray-600">
                        <RightOutlined />
                      </div>
                    </Button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      )} */}

            {body?.map((value, index) => {
              const tooltipMessage = getRowTooltip(value);
              const isClickable = isRowClickable(value);
              const cursorStyle = getRowCursor(value);
              const isLocked = value.path && value.path.featureKey;

              const rowContent = (
                <tr
                  key={index}
                  className={getRowClassName(value, index)}
                  onClick={(e) => isClickable && handleRowClick(value, e)}
                  onMouseEnter={() => setHoveredRow(index)}
                  onMouseLeave={() => setHoveredRow(null)}
                  style={{
                    cursor: cursorStyle,
                    opacity: isLocked ? 0.9 : 1,
                  }}
                >
                  {head?.map((val, ind) => (
                    <td
                      key={ind}
                      className={
                        ind === head?.length - 1
                          ? "p-4 text-center"
                          : val?.className || "p-4"
                      }
                    >
                      {value?.[val?.name] !== undefined && value?.[val?.name] !== null
                        ? value?.[val?.name]
                        : "-"}
                    </td>
                  ))}
                </tr>
              );

              return tooltipMessage ? (
                <Tooltip
                  title={tooltipMessage}
                  placement="top"
                  open={hoveredRow === index}
                >
                  {rowContent}
                </Tooltip>
              ) : rowContent;
            })}

          </table>
          {pagination?.currentPage ? (
            <div className="border-t p-4 bg-white sticky bottom-0 z-20">
              <div className="flex justify-between items-center text-gray-600 text-sm font-medium w-full">
                <div className="flex items-center">
                  <span className="pr-3">TOTAL</span>
                  <span>

                    {(() => {
                      const totalCount = Number(pagination?.totalCount) || 0;
                      const totalPages = Number(pagination?.totalPages) || 1;
                      const currentPage = Number(pagination?.currentPage) || 1;
                      const pageSize = totalPages > 0 ? Math.ceil(totalCount / totalPages) : 0;

                      const start = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
                      const end = Math.min(currentPage * pageSize, totalCount);

                      return (
                        <>
                          {start} - {end} &nbsp;OF&nbsp; {totalCount}
                        </>
                      );
                    })()}

                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    type="button"
                    className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleFirst}
                    disabled={pagination?.currentPage === 1}
                  >
                    <DoubleLeftOutlined className="text-xs" />
                  </button>

                  <button
                    type="button"
                    className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handlePrevious}
                    disabled={pagination?.currentPage === 1}
                  >
                    <LeftOutlined className="text-xs" />
                  </button>

                  <div className="flex items-center space-x-1">
                    {generatePageNumbers().map((page, index) => (
                      <button
                        key={index}
                        className={`px-3 py-1 rounded-md min-w-[40px] ${page === pagination?.currentPage
                          ? 'text-[#07b553] font-semibold'
                          : page === '...'
                            ? 'cursor-default text-gray-400'
                            : 'hover:text-[#07b553] text-gray-600'
                          }`}
                        onClick={() => typeof page === 'number' && handlePageChange(page)}
                        disabled={page === '...'}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleNext}
                    disabled={pagination?.currentPage === pagination?.totalPages}
                  >
                    <RightOutlined className="text-xs" />
                  </button>

                  <button
                    className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleLast}
                    disabled={pagination?.currentPage === pagination?.totalPages}
                  >
                    <DoubleRightOutlined className="text-xs" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {selectedFeature && (
            <FeatureUnlockRequestModal
              isOpen={isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setSelectedFeature(null);
              }}
              feature={selectedFeature}
              onSuccess={() => {
                console.log("Feature unlocked successfully!");
              }}
            />
          )}

        </div>
      </div>
    </div>
  );
};


export default Table;
